"use strict";

// базовый виджет
$.widget("fotobook.baseColorWidget", $.fotobook.containereditorbasecontrol, {
    "options" : {
        "alpha" : true,
    },
    _create: function(){
        this._super();
        this._initColorPicker();
    },
    _getColorPickerElement: function(){
        return this.element;
    },
    _initColorPicker: function(){
        var widget = this;

        this._getColorPickerElement().colorpicker({
            "color": this._getColorFromProject(),
            "alpha" : this.options.alpha !== false,
            "open" : function(event, data){
                widget._colorPickerOpen(data.formatted);
            },
            "select": function(event, data){
                if (data.formatted){
                    widget._colorPickerSetColor(data.formatted);
                }
            },
            "cancel": function(){
                widget._colorPickerCancel();
            },
            "ok": function(event, data){
                widget._colorPickerOk(data.formatted);
            },
            "close" : function(event, data){
                widget._colorPickerClose(data.formatted);
            },
        });
    },
    _colorPickerSetColor: $.noop,
    _colorPickerCancel: $.noop,
    _colorPickerOk: $.noop,
    _colorPickerOpen: function(color){
        this._getColorPickerElement().colorpicker("setColor", this._getColorFromProject());
    },
    _colorPickerClose: $.noop,
    _getColorFromProject: $.noop,
    _destroy: function(){
        this._getColorPickerElement().colorpicker("close", true);
        this._super();
    },
});

